module.exports = __webpack_public_path__ + "img/BlendBuff-Hate.f0ab2487.png";